import styled from "styled-components";
export const GlobalAdminAIPartnerEditViewParent = styled.div `
    max-width: 600px;
`;
export const FormField = styled.div `
    margin-bottom: 16px;
`;
export const FormLabel = styled.label `
    display: block;
    margin-bottom: 4px;
    font-weight: 500;
`;
export const FormInput = styled.input `
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;

    &:focus {
        outline: none;
        border-color: #1976d2;
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`;
export const FormTextarea = styled.textarea `
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    font-family: monospace;
    min-height: 100px;
    resize: vertical;

    &:focus {
        outline: none;
        border-color: #1976d2;
    }
`;
export const FormCheckbox = styled.input `
    margin-right: 8px;
`;
export const FormHelp = styled.span `
    display: block;
    margin-top: 4px;
    font-size: 12px;
    color: #666;
`;
export const ErrorMessage = styled.div `
    padding: 12px;
    margin-bottom: 16px;
    background-color: #ffebee;
    color: #c62828;
    border-radius: 4px;
`;
export const ButtonRow = styled.div `
    display: flex;
    gap: 12px;
    margin-top: 24px;
`;
